import type { Variants } from 'framer-motion';

export const EASE = {
  smooth: [0.6, 0.01, 0.05, 0.95] as const,
  spring: [0.34, 1.56, 0.64, 1] as const,
  elegant: [0.16, 1, 0.3, 1] as const,
  out: [0.22, 1, 0.36, 1] as const,
};

// 블러 효과가 있는 fade in up
// 기본 fade in up (블러 없음)
export const fadeInUp: Variants = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: EASE.elegant },
  },
};

// 스케일 + 페이드
// 컨테이너용 stagger
export const staggerContainer: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.1,
    },
  },
};

// 빠른 stagger (카드 리스트용)
export const staggerContainerFast: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.05,
    },
  },
};

// 카드용 stagger 아이템 (스케일 포함)
export const staggerCard: Variants = {
  hidden: {
    opacity: 0,
    y: 30,
    scale: 0.95,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.5,
      ease: EASE.out,
    },
  },
};

// 바운스 인
// 로고/아이콘 reveal (커스텀 딜레이)
// Hover 효과들
// 스프링 바운스 (더 드라마틱한 등장)
export const springBounce: Variants = {
  hidden: {
    opacity: 0,
    y: 60,
    scale: 0.85,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      type: 'spring',
      stiffness: 200,
      damping: 20,
      mass: 1,
    },
  },
};

// 플로팅 애니메이션 (떠다니는 효과)
// 플로팅 + 회전 (더 다이나믹)
// 펄스 글로우 (CTA 버튼용)
// 시선 유도용 셔플 (좌우 흔들림)
